import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const IdeaAccelerator = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "We work in tight sprints — usually one to two weeks. We map out the problem space, challenge your assumptions (professionally, we promise), identify the riskiest unknowns, and start designing against them. Concept sketches get turned into testable prototypes quickly, because the fastest way to learn is to show someone something real.",
    },
    {
      title: 'Delivery',
      description:
        "A validated concept pack: refined product proposition, user flow documentation, low-to-mid fidelity prototype, key assumptions tested, and a clear 'what next' recommendation. Enough to pitch with confidence or start building without second-guessing yourself.",
    },
    {
      title: 'Results',
      description:
        'Founders and product leads leave with clarity. Some find their original idea is gold and just needed shaping. Others discover a pivot that\'s far stronger. Either way, you know — before the expensive part — what you\'re actually building and why.',
    },
  ], []);

  return (
    <>
      <Seo 
        title="Idea Accelerator Services | Heretic Studio"
        description="Got an idea but not sure how to bring it to life? Accelerate the process with strategic thinking, rapid prototyping, user validation, and iterative design to help you build something people actually want to use."
      />
      <div className="studio-page">
        <div className="studio-hero">
          <div className="studio-hero__content">
            <h1 className="studio-hero__title">Idea Accelerator</h1>
            <p className="studio-hero__subtitle">From 'what if' to 'what's next' — fast.</p>
          </div>
        </div>

        <section className="section intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  Got an idea but not sure how to bring it to life? Accelerate the process
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default IdeaAccelerator;
